module.exports = [
  { id: '619', abbreviation: 'NTI', value: 'NZ: North Island', countryId: '6001' },
  { id: '620', abbreviation: 'STI', value: 'NZ: South Island', countryId: '6001' },
  { id: '621', abbreviation: 'SWI', value: 'NZ: Stewart Island', countryId: '6001' },
  { id: '622', abbreviation: 'CTI', value: 'NZ: Chatham Islands', countryId: '6001' },
];
